import React, { Suspense, useContext } from "react";
import RegionList from "./RegionList";
import { BrowserRouter, Route, Switch, Redirect, useHistory } from "react-router-dom";
import { LoginOrRegister } from "./LoginOrRegister";
import PrivateRoute from "../components/PrivateRoute";
import Account from "./Account";
import Apply from "./Apply";
import NavBar from "../components/NavBar";
import ChangePassword from "./ChangePassword";
import { EditAccount } from "./EditAccount";
import { useLanguage } from "../useLanguage";
import RegionTests from "./RegionTests";
import { FinishResetPassword, ResetPassword } from "./ForgotPassword";
import EventReserve from "./EventReserve";
import DeleteAccount from "./DeleteAccount";
import { FillQuestionnaire } from "./FillQuestionnaire";
import { EmailPreference } from "./EmailPreference";
import { StatusContext } from "../StatusContext";
import CenterContainer from "../components/CenterContainer";
import { UndrawContainer } from "../components/UndrawContainer";
import { ReactComponent as UndrawBuild } from "../data/undraw_build.svg";
import ReactGA from "react-ga";
import { CookieMessage } from "../components/CookieMessage";
import { TermsAndConditions } from "./TermsAndConditions";
import Spinner from "../components/Spinner";
import { EnableAccount } from "./EnableAccount";
import { UpdateSettings } from "./AccountCheckup";
import { FAQ } from "./FAQ";
import { TestQuestionnaire } from "./TestQuestionnaire";
import { GDPR } from "./GDPR";
const AdminRouter = React.lazy(() => import("./admin/AdminRouter"));

function Track() {
    const history = useHistory();
    history.listen(() => {
        window.scrollTo(0, 0);
        ReactGA.set({ page: window.location.pathname });
        ReactGA.pageview(window.location.pathname);
    });
    return null;
}

export function Router() {
    const language = useLanguage();
    const status = useContext(StatusContext);

    return (
        <BrowserRouter>
            <Track />
            <NavBar />
            <Suspense
                fallback={
                    <CenterContainer style={{ margin: "2em 0", fontSize: "1.2em" }}>
                        Adminpaneel laden... <Spinner />
                    </CenterContainer>
                }>
                <Switch>
                    <PrivateRoute admin={true} login={<LoginOrRegister />} path="/admin" component={AdminRouter} />

                    <Route path="/terms-and-conditions" component={TermsAndConditions} />
                    <Route path="/gdpr" component={GDPR} />
                    {status?.maintenanceMode && (
                        <Route>
                            <CenterContainer width="500px" style={{ margin: "5em 0", textAlign: "center" }}>
                                <h2>{language("maintenance-mode")}</h2>
                                <UndrawContainer style={{ margin: "2em 0" }}>
                                    <UndrawBuild />
                                </UndrawContainer>
                            </CenterContainer>
                        </Route>
                    )}
                    <Route path="/" exact component={RegionTests} />
                    <Route path="/faq" exact component={FAQ} />
                    <Route path="/reset-password/:s" component={FinishResetPassword} />
                    <Route path="/reset-password" component={ResetPassword} />
                    <Route path="/email-preference/:s" component={EmailPreference} />
                    <Route path="/enable-account/:email" component={EnableAccount} />
                    <Route path="/account-checkup/:s" component={UpdateSettings} />
                    <Route path="/test-questionnaire/:id" component={TestQuestionnaire} />
                    <PrivateRoute login={<LoginOrRegister />} path="/select-region" exact component={RegionList} />
                    <PrivateRoute login={<LoginOrRegister defaultMode="register" />} path="/register" component={RegionTests} />
                    <PrivateRoute login={<LoginOrRegister />} path="/fill-questionnaire/:id" component={FillQuestionnaire} />
                    <PrivateRoute login={<LoginOrRegister />} path="/change-password" component={ChangePassword} />
                    <PrivateRoute login={<LoginOrRegister />} path="/account/edit" component={EditAccount} />
                    <PrivateRoute login={<LoginOrRegister />} path="/account/delete" component={DeleteAccount} />
                    <PrivateRoute login={<LoginOrRegister />} path="/account" component={Account} />
                    <PrivateRoute login={<LoginOrRegister />} path="/login-home" component={RegionTests} />
                    <PrivateRoute login={<LoginOrRegister message={language("apply-require-login")} />} path="/apply/:id" component={Apply} />
                    <PrivateRoute
                        login={<LoginOrRegister message={language("apply-require-login")} />}
                        path="/reserve/:eventId"
                        component={EventReserve}
                    />
                    <Redirect to="/" />
                </Switch>
            </Suspense>
            <CookieMessage />
        </BrowserRouter>
    );
}
